export default "__VITE_ASSET__BXZi1AYF__"